import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { environment } from '../environments/environment';
import { API_BASE_URL } from './core/config/api-base-url.token';
import { FIREBASE_CONFIG } from './core/config/firebase-config.token';
import { GlobalErrorHandlerService } from './core/errors/global-error-handler.service';
import { authHeaderInterceptor } from './core/http/interceptors/auth-header.interceptor';
import { correlationIdInterceptor } from './core/http/interceptors/correlation-id.interceptor';
import { errorNormalizationInterceptor } from './core/http/interceptors/error-normalization.interceptor';
import { httpLoggingInterceptor } from './core/http/interceptors/http-logging.interceptor';
import { ssrForwardedHeadersInterceptor } from './core/http/interceptors/ssr-forwarded-headers.interceptor';
import { ConsoleLoggerService } from './core/logging/console-logger.service';
import { Logger } from './core/logging/logger.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withInterceptors([
        ssrForwardedHeadersInterceptor,
        authHeaderInterceptor,
        correlationIdInterceptor,
        httpLoggingInterceptor,
        errorNormalizationInterceptor,
      ]),
    ),
    {
      provide: API_BASE_URL,
      useValue: environment.apiBaseUrl,
    },
    {
      provide: FIREBASE_CONFIG,
      useValue: environment.firebase,
    },
    {
      provide: Logger,
      useClass: ConsoleLoggerService,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
};
